import { render, staticRenderFns } from "./DeleteRoleButton.vue?vue&type=template&id=0035cb4c&scoped=true&"
import script from "./DeleteRoleButton.vue?vue&type=script&lang=js&"
export * from "./DeleteRoleButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0035cb4c",
  null
  
)

export default component.exports